/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDealerDetailsHeader_viewer$ref = any;
export type PdpRespDealerDetailsStats_viewer$ref = any;
export type PdpRespDealerDetailsStats_viewer = {
    readonly " $fragmentRefs": PdpSharedDealerDetailsHeader_viewer$ref;
    readonly " $refType": PdpRespDealerDetailsStats_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespDealerDetailsStats_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedDealerDetailsHeader_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '3370d93dc149e58bd5d1350881097937';
export default node;
